import React from "react";
import DateBox from "./DateBox";
import { LoginIcon, LogoutIcon, WarningIcon, FlightIcon } from "./Icons";
import { getStatusCfg, parseDate } from "./statusHelpers";


export default function AttendanceItem({ item }) {
    const { dayNum, monthShort, dayName } = parseDate(item.date);
    const cfg = getStatusCfg(item.status);

    const showNoPunch =
        item.inTime === "--" &&
        item.outTime === "--" &&
        (item.status.toLowerCase().includes("absent") ||
            item.status.toLowerCase().includes("week off") ||
            item.status.toLowerCase().includes("holiday"));

    const extras = [];
    if (item.penaltyReason)
        extras.push({
            text: item.penaltyReason,
            type: "warning",
            color: "#F44336",
        });
    if (item.isTravel && item.travelFlagged && item.travelFlagReason)
        extras.push({
            text: item.travelFlagReason,
            type: "flight",
            color: "#9C27B0",
        });
    else if (item.isTravel)
        extras.push({ text: "Travel Day", type: "flight", color: "#9C27B0" });

    return (
        <div className="relative mx-3 mb-2.5">
            {/* TODAY badge — sits above the card */}
            {item.isToday && (
                <div className="absolute -top-3.5 right-3 z-10 bg-[#FDC700] px-2.5 py-0.5 rounded-lg shadow-sm">
                    <span className="text-[10px] font-bold text-black tracking-wider">
                        TODAY
                    </span>
                </div>
            )}

            {/* Card */}
            <div
                className={`rounded-2xl p-3.5 bg-white ${
                    item.isToday
                        ? "border-2 border-[#FDC700] mt-4"
                        : "border border-gray-100"
                }`}
                style={{ boxShadow: "0 1px 6px rgba(0,0,0,0.06)" }}
            >
                {/* Main row */}
                <div className="flex items-center">
                    <DateBox
                        dayNum={dayNum}
                        monthShort={monthShort}
                        dayName={dayName}
                        status={item.status}
                    />

                    <div className="flex-1 min-w-0">
                        {/* Status badge */}
                        <span
                            className="inline-block text-[11px] font-bold px-2.5 py-1 rounded-full"
                            style={{ color: cfg.text, backgroundColor: cfg.bg }}
                        >
                            {item.status}
                        </span>

                        {/* Time row */}
                        {showNoPunch ? (
                            <p className="text-[11px] text-gray-400 mt-1.5">
                                No attendance recorded
                            </p>
                        ) : (
                            <div className="flex items-center gap-1 mt-1.5 text-gray-400 flex-wrap">
                                <LoginIcon />
                                <span className="text-[11px]">
                                    {item.inTime}
                                </span>
                                <span className="text-[11px] text-gray-300 mx-0.5">
                                    →
                                </span>
                                <LogoutIcon />
                                <span className="text-[11px]">
                                    {item.outTime}
                                </span>
                            </div>
                        )}

                        {/* Working hours */}
                        <p className="text-[11px] text-gray-400 mt-0.5">
                            ⏱ {item.hours}
                        </p>
                    </div>
                </div>

                {/* Extras (penalty / travel) */}
                {extras.length > 0 && (
                    <div className="mt-2.5 pt-2.5 border-t border-gray-100 flex flex-col gap-1.5">
                        {extras.map((e, i) => (
                            <div key={i} className="flex items-center gap-1.5">
                                {e.type === "warning" ? (
                                    <WarningIcon color={e.color} />
                                ) : (
                                    <FlightIcon color={e.color} />
                                )}
                                <span
                                    className="text-[11px]"
                                    style={{ color: e.color }}
                                >
                                    {e.text}
                                </span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
